import type { ButtonProps } from '@vakantiesnl/components/src/atoms/Button/Button.types';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles<{ toggleVariant: ButtonProps['variant'] }>()(
	(theme, { toggleVariant = 'primary' }) => ({
		adlinksList: {
			display: 'flex',
			flexDirection: 'column',
		},
		showMoreButton: {
			width: toggleVariant === 'primary' ? '100%' : 'unset',
		},
		adLinksContainer: {
			display: 'flex',
			flexDirection: 'column',
			gap: theme.spacing.medium,
		},
		favoriteButton: {
			color: theme.button.secondary.label.color.default,

			'&&': {
				backgroundColor: theme.palette.neutral[0],
			},

			'&:hover': {
				borderColor: theme.button.secondary.border.color.default,
				color: theme.body.foreground.color.mandatory,
			},
		},
		favoriteButtonActive: {
			color: theme.body.foreground.color.mandatory,

			'&:hover': {
				color: 'initial',
			},
		},
		buttonContainer: {
			marginTop: theme.spacing.small,
			display: 'flex',
			justifyContent: 'column',
			gap: theme.spacing.xxsmall,
		},
	}),
);
